import React from 'react'
import { Switch } from 'react-router-dom'
import Connect from './containers/Connect'
import Results from './containers/Results'
import AppliedRoute from './components/AppliedRoute'
import NotFound from './containers/NotFound'
import PropTypes from 'prop-types'

export default function Routes({ childProps }) {
	return (
		<Switch>
			<AppliedRoute path={'/connect/:airtableId'} exact component={Connect} props={childProps} />
			<AppliedRoute path={'/results/:reportId'} exact component={Results} props={childProps} />
			<AppliedRoute component={NotFound} props={childProps} />
		</Switch>
	)
}

Routes.propTypes = {
	childProps: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/Routes.js